/* tslint:disable */
import {
  UserProfile,
  ChartOfAccount
} from '../index';

declare var Object: any;
export interface LandlordChartOfAccountInterface {
  "etims_item_code"?: string;
  "digitax_item_id"?: string;
  "chart_of_account_id": number;
  "user_profile_id": number;
  "queue_status"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  landlord?: UserProfile;
  chartOfAccount?: ChartOfAccount;
}

export class LandlordChartOfAccount implements LandlordChartOfAccountInterface {
  "etims_item_code": string;
  "digitax_item_id": string;
  "chart_of_account_id": number;
  "user_profile_id": number;
  "queue_status": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  landlord: UserProfile;
  chartOfAccount: ChartOfAccount;
  constructor(data?: LandlordChartOfAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LandlordChartOfAccount`.
   */
  public static getModelName() {
    return "LandlordChartOfAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LandlordChartOfAccount for dynamic purposes.
  **/
  public static factory(data: LandlordChartOfAccountInterface): LandlordChartOfAccount{
    return new LandlordChartOfAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LandlordChartOfAccount',
      plural: 'LandlordChartOfAccounts',
      path: 'LandlordChartOfAccounts',
      idName: 'id',
      properties: {
        "etims_item_code": {
          name: 'etims_item_code',
          type: 'string'
        },
        "digitax_item_id": {
          name: 'digitax_item_id',
          type: 'string'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "user_profile_id": {
          name: 'user_profile_id',
          type: 'number'
        },
        "queue_status": {
          name: 'queue_status',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        landlord: {
          name: 'landlord',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'user_profile_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
      }
    }
  }
}
